import { IPage, MalibleDistribution, MalibleMode } from '@malible/distribution'
import { FAILED_FETCH_DATA } from 'utils/sentry/sentry-messages'
import { captureError } from 'utils/sentry/sentry-utils'

const malibleDistribution = new MalibleDistribution({
  apiKey: process.env
    .REACT_APP_MALIBLE_API_KEY as keyof typeof MalibleDistribution,
  workspaceId: process.env
    .REACT_APP_MALIBLE_WORKSPACE_ID as keyof typeof MalibleDistribution,
  mode: MalibleMode[
    process.env.REACT_APP_MALIBLE_MODE as keyof typeof MalibleMode
  ],
  baseURL: process.env.REACT_APP_MALIBLE_BASE_URL,
})

export const getPageData = async (pageId: string) => {
  try {
    const response: IPage | null = await malibleDistribution.getPageById(pageId)
    return response
  } catch (error) {
    captureError(FAILED_FETCH_DATA, {
      error,
      functionName: 'getPageData',
    })
  }
}
